import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../components/contentfrom";
import { Link } from "gatsby";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Ready for Your Next Big App?</h2>
            </div>
            <p>
              We enable global organizations – solopreneurs and startups to
              establish corporations to achieve competitive advantage. All our
              digital strategies, covering MVPs to large-scale product
              development, aim to deliver strong engagement and business value.
              Our goals and vision have made us what we're today - a preeminent{" "}
              <Link to="/mobile-app-development" target="_blank" rel="noopener">
                mobile app development company
              </Link>{" "}
              in the United States.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
